import React, { useState, useEffect, useMemo } from 'react';
import { RadioButtonSet } from 'src/components/Quiz/RadioButtonSet';
import { Footer } from 'src/components/Quiz/Footer';
import { trackEvent } from 'src/services/analytics';
import { useSearchContext } from 'src/components/Providers/SearchProvider';
import { QuizQuestion } from 'src/components/Quiz/QuizQuestion';
import { getGoals } from '@src/containers/QuizContainer/answerHelpers';
import {
	AnswerKeys,
	EducationValues,
	QuizAnalytics,
	ScreenProps,
} from '@src/containers/QuizContainer/types';
import { educationalGoals } from '@src/containers/QuizContainer/answerMapping';
import { useQuiz, useQuizDispatch } from '@src/components/Providers/QuizProvider';
import styles from './Goal.module.scss';

export const nonDegreeGoals = educationalGoals.filter(goal => goal.nonDegree);

const question = "What's your educational goal?";

export const Goal: React.FC<ScreenProps> = props => {
	const { filters, index } = useSearchContext();
	const { answers } = useQuiz();
	const { dispatch } = useQuizDispatch();
	const { defaultAnswers, nextScreen, previousScreen, updateAnswers } = props;
	const [validGoals, setValidGoals] = useState([]);

	const defaultGoal = answers?.goal ? answers.goal : defaultAnswers?.goal || undefined;
	const [goalAnswer, setGoalAnswer] = useState<string>(defaultGoal);

	const analyticsData: QuizAnalytics = useMemo(() => {
		return {
			questionKey: question,
			questionType: 'radioButtons',
		};
	}, []);

	useEffect(() => {
		const fetchGoals = async () => {
			const goals = await getGoals(answers, filters, index);

			if (goals.length < 2) {
				const goalAnswer = { [AnswerKeys.goal]: goals[0].label };
				const newAnswers = Object.assign(answers, goalAnswer);
				dispatch({ type: 'updated_answers', answers: newAnswers });
			}

			if (answers.education !== EducationValues['Some high school']) {
				const newGoals = goals.filter(goal => goal.label !== EducationValues['Finish high school']);
				setValidGoals(newGoals);
			} else {
				setValidGoals(goals);
			}
		};

		fetchGoals();
	}, [filters, answers, dispatch, index]);
	useEffect(() => {
		trackEvent('userProgramQuizQuestionAttempted', analyticsData);
	}, [analyticsData]);

	return (
		<>
			<fieldset className={styles.container} data-testid='goal'>
				<legend className={styles.title} data-testid='goal-question'>
					<QuizQuestion question={question} />
				</legend>
				<RadioButtonSet onSelect={setGoalAnswer} options={validGoals} value={goalAnswer} />
			</fieldset>
			<Footer
				disableNext={!goalAnswer}
				onClickNext={() => {
					analyticsData.responseKey = goalAnswer;
					updateAnswers({ [AnswerKeys.goal]: goalAnswer }, answers);
					trackEvent('userProgramQuizQuestionCompleted', analyticsData);
					nextScreen();
				}}
				onClickPrevious={previousScreen}
			/>
		</>
	);
};
